import logoUrl from "../../img/themes/leverant/logo_med_tekst.svg";
import { type CustomerFeature, FEATURE_NAME } from "../common/types/featureTypes";
import { ORDERTYPE } from "../common/types/productOrderTypes";
import type { SiteConfig } from "../common/types/themeTypes";

/**
 * Parses the response bodies into suitable data structure for use in stores. Diplomis does not up pickup alternatives
 */

const leverantSiteConfig: SiteConfig = {
   storeId: "leverant",
   storeCompanyName: "Leverant",
   siteName: "Leverant Handel",
   orderSupportEmail: "kontakt@leverant.no",
   m3CompanyNumber: "100",
   m3DivisionNumber: "102",
   defaultOrderType: ORDERTYPE.LEV,
   storeLogo: {
      searchbar: {
         url: logoUrl,
         width: 72
      },
      searchbarMobile: null,
      footer: null
   },
   mainMenuProductCategoryLevel: 1,
   showComparisonPrice: false,
   tipApiPrefix: "lev-",
   faqSlug: "",
   filterAttributes: () => ({ brand: "Type" }),
   papirflyApsCustomerId: "12590",
   papirflyApsImagePrefix: "",
   baseUrl: "",
   fetchCustomerFeatures: () => {
      return Promise.resolve([
         { name: FEATURE_NAME.invoicePaymentAvailable, description: "Makes invoice overview available" },
         { name: FEATURE_NAME.createOrderAvailable, description: "Allows customer to place orders" },
         { name: FEATURE_NAME.subscriptionOrderAvailable, description: "Allows customer to place subscription orders" }
      ] satisfies CustomerFeature[]);
   },
   invoiceTooltipText: () => "",

   deliveryFee: {
      enabled: false
   },
   productAvailability: {
      enabled: false
   },
   isLegacyFilters: true,
   newCustomerForm: "mailto:kontakt@leverant.no",
   deliveryNotes: {
      visible: false
   },
   deliveryMethod: "inhouse",
   searchConfig: null,
   contentImages: {
      cloudinaryMapping: "leverant_images"
   },
   contactForm: {
      reasons: [
         { value: "claims", label: "Reklamasjon", label_en: "Claims" },
         { value: "invoice", label: "Fakturaspørsmål / endring av fakturaadresse", label_en: "Invoice address changes" },
         { value: "delivery", label: "Ønske om levering før oppsatt leveringsdag", label_en: "Questions about ordering" },
         { value: "product_question", label: "Spørsmål om våre produkter eller sortiment", label_en: "Question about products" },
         { value: "new_customer", label: "Ny kunde?", label_en: "New customer?" },
         { value: "other", label: "Annet", label_en: "Other" }
      ]
   },
   whileYouWaitMessage: "Ta frem kaffekoppen, len deg tilbake og nyt soloppgangen!",
   notifications: {
      categories: [
         { id: "IMPORTANT_INFO_ABOUT_DELIVERY", name: "Viktige meldinger om levering" },
         { id: "ORDER_CONFIRMATION", name: "Ordrebekreftelse" }
      ],
      enableDeliveryMessages: false
   },
   orderConfirmation: {
      headerSubTitle: ""
   },
   cart: {
      showReferencesByDefault: true,
      customerReferenceLabel: "Kommentar"
   },
   promotionsPage: {
      enabled: false
   },
   allowFreeProducts: false
};

export default leverantSiteConfig;
